import React from 'react';
import { useLocation } from 'umi';
import './index.less';

const Header: React.FC = () => {
  const location = useLocation();

  const getNavItemClass = (path: string) => {
    const currentPath = location.pathname;
    // console.log('currentPath', currentPath);
    // 默认选中welcome页面
    if (currentPath === '/' && path === '/welcome') return 'nav-item active';
    if (path === '/welcome' && currentPath === '/welcome') return 'nav-item active';
    if (path !== '/welcome' && path !== '/' && currentPath.startsWith(path)) return 'nav-item active';
    return 'nav-item';
  };

  return (
    <div className="page-header">
      <div className="header-content">
        {/* 上层：大logo */}
        <div className="logo-section">
          <div className="logo">
            <img src="/assets/logo.png?v2" alt="CSIDA Logo" className="logo" />
          </div>
        </div>

        {/* 下层：导航栏 */}
        <div className="nav-section">
          <nav className="main-nav">
            <a href="/welcome" className={getNavItemClass('/welcome')}>首页</a>
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/association')} onClick={(e) => e.preventDefault()}>协会概况 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/association/introduction">协会简介</a>
                <a href="/association/leadership">负责人介绍</a>
                <a href="/association/charter">协会章程及自律公约</a>
                <a href="/association/organization">组织机构</a>
                {/* <a href="/association/branches">分支机构</a> */}
                <a href="/association/qualifications">资质与荣誉</a>
              </div>
            </div>
            <span className="nav-divider">|</span>
            <a href="/party/news" className={getNavItemClass('/party')}>党建工作</a>
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/news')} onClick={(e) => e.preventDefault()}>行业资讯 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/news/announcements">通知公告</a>
                <a href="/news/industry">行业动态</a>
                <a href="/news/expert-opinions">专家论道</a>
              </div>
            </div>
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/experts')} onClick={(e) => e.preventDefault()}>专家智库 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/experts/senior-advisors">高级顾问</a>
                <a href="/experts/industry-experts">行业专家</a>
                <a href="/experts/skilled-talents">技能人才</a>
              </div>
            </div>
            {/* <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/training')} onClick={(e) => e.preventDefault()}>蓝盾大讲堂 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/training/vocational">职业培训</a>
                <a href="/training/engineer">工程师培训</a>
                <a href="/training/certification">能力验证</a>
              </div>
            </div> */}
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/evaluation')} onClick={(e) => e.preventDefault()}>咨询服务 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/evaluation/system-files">标准体系</a>
                {/* <a href="/evaluation/login-declaration">登录申报</a> */}
                {/* <a href="/evaluation/declaration-guide">申报指南</a> */}
                <a href="/evaluation/certificate-info" rel="noopener noreferrer">证书信息</a>
                {/* <a href="https://www.afdata.org.cn/identificationInfo" target="_blank" rel="noopener noreferrer">认定信息</a> */}
                {/* <a href="https://www.afdata.org.cn/publicityInfo" target="_blank" rel="noopener noreferrer">公示信息</a> */}
                {/* <a href="/evaluation/supervision">监督管理</a> */}
                <a href="/evaluation/contact">能评咨询</a>
                <a href="/evaluation/announcements">通知公告</a>
              </div>
            </div>
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/members')} onClick={(e) => e.preventDefault()}>会员服务 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/members/showcase">会员风采</a>
                <a href="/members/application">入会申请</a>
              </div>
            </div>
            <span className="nav-divider">|</span>
            <div className="nav-item-dropdown">
              <a className={getNavItemClass('/contact')} onClick={(e) => e.preventDefault()}>联系我们 <span className="dropdown-arrow">⌄</span></a>
              <div className="dropdown-menu">
                <a href="/contact/info">联系方式</a>
                <a href="/contact/map">地图标注</a>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Header;